import { render, staticRenderFns } from "./ThuNganForm.vue?vue&type=template&id=bb7d86a6&"
import script from "./ThuNganForm.vue?vue&type=script&lang=js&"
export * from "./ThuNganForm.vue?vue&type=script&lang=js&"
import style0 from "./ThuNganForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports